import { useEffect } from "react";

export default function RouteFocusManager({ pathname }) {
  useEffect(() => {
    const main = document.getElementById("main-content");
    if (!main) return;
    main.focus({ preventScroll: true });
  }, [pathname]);
  return null;
}
